import React, { useEffect, useState } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import back from "../../Asset/product/back.png";
import userModel from "../../model/user.model";
import { useContact } from "../../useContext/ContactContext";
import { toast } from "../../lib/helper";
import logo from "../../Asset/ordercard/logo.png"
import wrong from "../../Asset/toast/wrong.png"
import AOS from "aos";
import "aos/dist/aos.css";

const EditUser = ({ setEditstatus, editstatus }) => {
  const {userdata, GetUser } = useContact();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [gender, setGender] = useState(userdata && userdata?.data?.gender);
  const[Loading,setloading]=useState(false)


  const Edit =async(e)=>{
    setloading(true);
    e.preventDefault();
    const form = new FormData(e.target)
    userModel.Edit(form)
    .then((responce)=>{
      setloading(false);
      toast(responce?.data?.message,logo)
        setEditstatus(false);

      console.log("rrrrrrr",responce)
    GetUser();
    })
    .catch((error)=>{
      setloading(false);
      console.log("error",error)
    })
  }

 useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="w-full fixed inset-0 bg-black/50 flex justify-center items-center overflow-y-auto " onClick={() => setEditstatus(false)}>
      <div data-aos="flip-up" className="xl:w-2/5 md:w-1/2 lg:w-1/2 sm:w-11/12 w-11/12 bg-Background1 rounded-xl shadow-lg shadow-textColor" style={{ backgroundImage: `url(${back})`}} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-white/50 relative rounded-3xl   w-full h-full flex items-center justify-center">
          <div className="p-4  md:p-3 sm:p-6 xl:p-4 lg:p-5 2xl:p-8 absolute top-0 w-full ">
            <div className="">
              <div className="flex justify-between  items-center">
                <span className="text-2xl font-bold text-textColor">
                  Profile
                </span>
                <RiCloseCircleFill
                  className=" text-4xl lg:text-3xl md:text-xl cursor-pointer hover:text-red-500"
                  onClick={() => setEditstatus(false)}
                />
              </div>
            </div>
          </div>
          <form className="w-3/4 pt-20 " onSubmit={Edit}>
            <div className="w-full flex flex-col gap-4 ">
              <div className="flex flex-col sm:flex-row gap-2 sm:items-end items-start">
                <div
                  className="w-20 h-20 bg-white p-2 cursor-pointer"
                  onClick={() => {
                    if (userdata?.data?.profile_pic_link) {
                      window.open(userdata?.data?.profile_pic_link, "_blank");
                    }
                  }}
                >
                  <img
                    src={userdata && userdata?.data?.profile_pic_link}
                    alt="img"
                    className="w-full h-full object-cover"
                  />
                </div>
                <input type="file" name="profile_pic"/>
              </div>
              <input
                type="email"
                name="email"
              readOnly
                defaultValue={userdata && userdata?.data?.email}
                placeholder="Email"
                className="w-full p-2  border rounded-md"
              />
              <input
                type="text"
                name="name"
                defaultValue={userdata && userdata?.data?.name}
                placeholder="Write Full Name"
                className="w-full p-2  border rounded-md"
              />
              <input
                type="number"
                name="age"
                defaultValue={userdata && userdata?.data?.age}
                placeholder="Age"
                className="w-full p-2  border rounded-md"
              />
              <input
                type="number"
              readOnly
                defaultValue={userdata && userdata?.data?.contact_no}
                placeholder=""
                
                className="w-full p-2  border rounded-md cursor-not-allowed"
              />
              <div className="flex gap-4 w-full">
                <label className="flex-1 flex items-center gap-2 border bg-white p-2 sm:p-4 md:p-0.5 lg:p-1 2xl:p-2 rounded-md cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="Male"
                    checked={gender === "Male"}
                    onChange={(e) => setGender(e.target.value)}
                    className="border rounded-md"
                  />
                  <span>Male</span>
                </label>
                <label className="flex-1 flex items-center gap-2 bg-white border sm:p-4 2xl:p-2 p-2 md:p-0.5 lg:p-1 rounded-md cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="Female"
                    onChange={(e) => setGender(e.target.value)}
                    checked={gender === "Female"}
                    className="border rounded-md"
                  />
                  <span>Female</span>
                </label>
              </div>

              <div className="w-full mt-5 mb-6 sm:mb-8 md:mt-2 md:mb-2 lg:mb-5 xl:mb-4 lg:mt-2 xl:mt-3 2xl:mb-10 2xl:mt-8">
                <button
                  className="w-full bg-textColor text-white py-2  sm:py-3 md:py-0.5 lg:py-1 2xl:py-2 rounded-3xl"
                  type="submit"
                >
                 {Loading ? <span className="loading loading-dots loading-md"></span> : "Update"} 
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
